import { useEffect } from "react";
import styles from "./ProductView.module.css";

type Props = {
    title: string;
    onClose: () => void;
    processes: any[];
}

const Popup = ({ title, processes, onClose }: Props) => {
  useEffect(() => {
    const handleEsc = (event: any) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <div className={styles.popupOverlay}>
      <button
        className={styles.popupBackdrop}
        onClick={onClose}
        onKeyDown={onClose}
      />
      <div className={styles.popupContent}>
        <span
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10%",
          }}
        >
          <h2 style={{ flexGrow: 1, margin: 0 }}>{title}</h2>
          <button
            className={styles.closeButton}
            onClick={onClose}
            onKeyDown={onClose}
          >
            <img
              src={require("../../assets/x.png")}
              width={15}
              height={15}
              alt="android ico"
              className={styles.closeButton}
            />
          </button>
        </span>

        <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
          {processes
            .sort((a, b) => a.ordinamento - b.ordinamento)
            .map((process) => (
              <span key={process.id}>
                <div className={styles.processItem}>
                  <div className={styles.processInfo}>
                    <div>
                      <h5>{process.denominazione}</h5>
                    </div>
                    <div>{process.descrizione}</div>
                  </div>
                  <button
                    className="btn btn-primary btn-xs"
                    style={{ margin: 0 }}
                    onClick={() => window.open(process.link, "_blank")}
                  >
                    Avvia
                  </button>
                </div>
                <hr />
              </span>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Popup;